import React from 'react';

const ReporterPodcast = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Podcast Management</h1>
      {/* Add your podcast management content here */}
    </div>
  );
};

export default ReporterPodcast;